import { Component } from 'react';
import PropTypes from 'prop-types';

import Leaflet from 'leaflet';

/**
 * Component that show a GeoJSON overlay on a map
 */
class MapGeoJSONLayer extends Component {
   constructor(props) {
      super(props);

      this.zoomOption = { weight: props.strokeWidth, opacity: props.opacity }
      this.zoomOptions = new Map();
      props.zoomOptions.forEach((opt) => {
         this.zoomOptions.set(opt.zoom, { opacity: opt.opacity, weight: opt.width });
      });
   }

   componentDidMount() {
                             // Create layer and add to map
      this.createJsonLayer();
   }

   componentWillUnmount() {
      this.layer.remove();
   }

   componentDidUpdate(prevProps) {
                             // Update image layer
      if (this.props.data !== prevProps.data) {
         this.layer.remove();
         this.createJsonLayer();
      }
   }

   /**
    * creates the json layer from data
    */
   createJsonLayer() {
      this.layer = Leaflet.geoJSON(this.props.data, {
         zIndex: this.props.layerOrder,
         style: { weight: this.zoomOption.weight, color: this.props.color, opacity: this.zoomOption.opacity },
         pane: 'geoJsonPane'
      });
      this.layer.addTo(this.props.map);
      this.props.map.on("zoomend", () => this.setStyleFromZoom());
   }

   /**
    * Set style from zoom level
    */
   setStyleFromZoom() {
      var currentZoomLevel = this.props.map.getZoom();

      var weight = this.props.strokeWidth;
      var opacity = this.props.opacity;

      // Trouver le plus gros zoom dans la config qui ne dépasse
      // pas le zoom courant, par ex si dans la config on a 10 15 20
      // et le zoom courant est de 12, on va appliquer les config du 10
      for (var [key, value] of this.zoomOptions) {
         if (key <= currentZoomLevel) {
            weight = value.weight;
            opacity = value.opacity;
         } else {
            break;
         }
      }

      if (this.zoomOption.weight !== weight || this.zoomOption.opacity !== opacity) {
         this.zoomOption = { weight, opacity };
         this.layer.setStyle({ weight, opacity });
         // ** hack, il semble avoir un bogue dans leaflet qui fait un reset de l'opacité à 1
         // ** on force un redraw de cette façon, c'est aussi pour cette raison qu'on fait un setStyle
         // ** seulement si le style à changé
         this.props.map.panBy([0,1]);
      }
   }

   /**
    * renders the image overlay component
    */
   render() {
      return (null);
   }
}

MapGeoJSONLayer.defaultProps = {
   strokeWidth : 2,
   opacity: 0.3,
   zoomOptions: []
}

MapGeoJSONLayer.propTypes = {
   /**
    * Color of the path strokes for the geoJson data
    */
   color: PropTypes.string,
   /**
    * GeoJson object to display, can also be an array of coordinates
    */
   data: PropTypes.object,
   /**
    * defines the layer order in the map.
    */
   layerOrder: PropTypes.number,
   /**
    * defines the map object on which to add the layer
    */
   map: PropTypes.object,
   /**
    * Stroke opacity (alpha channel), must be between 0 and 1
    */
   opacity: PropTypes.number,
   /**
    * Stroke width
    */
   strokeWidth: PropTypes.number,
   /**
    * Opacity and weight by zoom level
    */
   zoomOptions: PropTypes.array
}
export default MapGeoJSONLayer;
